import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

import { AvatarCardVO } from "../../../gamevo/AvatarCardVO";

export class Poker2AvatarCardDialogProperties extends BasicDialogProperties {
    public rankingAvatarVO: AvatarCardVO;

    constructor(rankingAvatarVO: AvatarCardVO) {
        super();

        this.rankingAvatarVO = rankingAvatarVO;
    }
}
